import Application from './application';
import { trackEvent, getQueryStringVariable } from './utilities/index';
import Overlay from "./overlay";

let Results = function (params) {
  // console.log('Results initalizing ' + params);

  /**
   *
   */
  let self = this;
  let mainEl = document.getElementById('main');
  let ResultsElement = document.getElementById( 'results' );
  let background = ResultsElement.querySelector('.bg-image' );
  let primaryTitle = ResultsElement.querySelector('h2.primary' );
  let alternativeTitle = ResultsElement.querySelector('h2.alternative');
  let compareTitle = ResultsElement.querySelector('h2.compare');
  let logo = ResultsElement.querySelector('.iron-logo' );
  let description = ResultsElement.querySelector('.iron-description' );
  let btnWhy = ResultsElement.querySelector('.btn-why' );
  let learnMore = ResultsElement.querySelector('.more-content' );
  let moreButton = ResultsElement.querySelector('.more-button' );
  let fittingButton = ResultsElement.querySelector('.fitting-button' );
  let clubImage = ResultsElement.querySelector('.selected-iron');
  let clubName = ResultsElement.querySelector('.iron-title');
  let clubVideo = ResultsElement.querySelector('.selected-iron-video' );
  let playVideoButton = ResultsElement.querySelector('.play-video-btn' );
  let closeVideoButton = ResultsElement.querySelector('.iron-video-close' );
  let mpiButtonWrap = ResultsElement.querySelector('.mpi-button-wrap' );
  let mpiButton = ResultsElement.querySelector('.mpi-button-wrap .mpi-button' );
  let restartButton = ResultsElement.querySelector('.restart-btn');
  let previousButton = ResultsElement.querySelector('.results-back-btn');
  let sendResultsButton = ResultsElement.querySelector('.send-results');
  let ctaButtons = ResultsElement.querySelector('.buy-links');
  let compareButton = ResultsElement.querySelector('.compare-both-button');
  let showAlternativeButton = ResultsElement.querySelector('.show-alternative-results-button');
  let showPrimaryButton = ResultsElement.querySelector('.show-primary-results-button');
  let mpiElement = ResultsElement.querySelector('#mpi-value');
  let timeline;
  let nextPage = "primary";
  let ironId = "";
  let overlay = new Overlay();
  let primaryId = '';
  let alternateId = '';
  let primaryFIid = '';
  let alternateFIid = '';
    let mode = '';
    let isExpanded = false;

  this.open = function() {
    console.log('Results.open');
    // set new height
    mainEl.classList.add('results-visible');
    window.ironSelector.fillProgressBar();
    this.setResults();
    moreButton = ResultsElement.querySelector('.more-button-' + ironId );
    TweenLite.set( [background, primaryTitle, alternativeTitle, logo, description, btnWhy, mpiButton, learnMore, clubImage, clubName, ctaButtons], {opacity: 0});
    ResultsElement.style.display = 'block';
    timeline = new TimelineLite({onComplete: this.openComplete, onCompleteScope: this});
    timeline.to(background, Application.tweenLength, {opacity: 1});
    timeline.to([primaryTitle, alternativeTitle, logo, description, btnWhy, mpiButton], Application.tweenLength, {opacity: 1}, Application.tweenStagger);
    timeline.to(learnMore, Application.tweenLength, {opacity: 1}, Application.tweenStagger);
    timeline.to([ctaButtons, clubImage, clubName], Application.tweenLength, {opacity: 1}, Application.tweenStagger);
    timeline.play();
  };

  this.setResults = function () {
    let partner = false;
    try {
        if (getQueryStringVariable('partner') === "true") {
            partner = true;
        }
    } catch (e) {
        console.log('Error getting partner query string variables');
    }

      if (partner) {
          
          document.querySelectorAll('.more-button,.send-results,.fitting-button,.virtual-fitting-button,.product-button-wrap .btn-tertiary').forEach(function (el) {
              el.style.display = 'none';
          });
      }
    // ironId = window.ironSelector.calculateResults();
    let sortedScores = window.ironSelector.calculateResults();
    console.log(sortedScores[0].id, sortedScores[1].id);
    overlay.setCompareIrons(sortedScores[0].id, sortedScores[1].id);
    let mpi = 75;
    if (nextPage === "alternative") {
      ironId = sortedScores[1].id;
      // toggle buttons
        showPrimaryButton.classList.remove('active');
        compareButton.classList.remove('active');
        showAlternativeButton.classList.add('active');
      //showAlternativeButton.style.display = 'none';
        alternativeTitle.style.display = 'block';
        primaryTitle.style.display = 'none';
        compareTitle.style.display = 'none';

      mpi = Math.min(Math.max(window.ironSelector.getMPI(ironId), 75), 98);
    } else {
      ironId = sortedScores[0].id;
      // toggle buttons
      //showPrimaryButton.style.display = 'none';
        //showAlternativeButton.style.display = 'inline-block';
        showPrimaryButton.classList.add('active');
        compareButton.classList.remove('active');
        showAlternativeButton.classList.remove('active');
        compareTitle.style.display = 'none';
        alternativeTitle.style.display = 'none';
        primaryTitle.style.display = 'block';
      mpi = Math.min(Math.max(window.ironSelector.getMPI(ironId), 81), 100);
    }
    // set mpi values on results screen
    console.log('setting mpi to ' + mpi);
    mpiElement.innerHTML = mpi.toString() + '%';
    // set mpi values on the compare screens
    primaryId = sortedScores[0].id;
    alternateId = sortedScores[1].id;
    document.getElementById('mpi-' + primaryId).innerHTML = Math.min(Math.max(window.ironSelector.getMPI(primaryId), 81), 100) + '%';
    document.getElementById('mpi-' + alternateId).innerHTML = Math.min(Math.max(window.ironSelector.getMPI(alternateId), 75), 98) + '%';

    console.log('selected iron id is: ' + ironId);
    ResultsElement.classList.add('show-' + ironId);
    nextPage = "";

    //debugger;

    let irons = document.getElementsByClassName('iron-wrap')[0]
    primaryFIid = irons.querySelector('div[data-iron="' + primaryId +'"]').getAttribute('data-ironid');
    alternateFIid = irons.querySelector('div[data-iron="' + alternateId +'"]').getAttribute('data-ironid');

    // track here or in the application?
    trackEvent('Recommendation', 'Primary', sortedScores[0].id);
    trackEvent('Recommendation', 'Alternative', sortedScores[1].id);
    // console.log('Primary', sortedScores[0]);
    // console.log('Alternative', sortedScores[1]);
  };

  this.openComplete = function () {
    // todo: initialize controls
      restartButton.addEventListener('click', this.homeClicked);
      previousButton.addEventListener('click', this.previousClicked);
    sendResultsButton.addEventListener('click', this.sendResultsClicked);
    showAlternativeButton.addEventListener('click', this.alternativeClicked);
    showPrimaryButton.addEventListener('click', this.primaryClicked);
    compareButton.addEventListener('click', this.compareClicked);
    //btnWhy.addEventListener('click', this.whyClicked);
    //playVideoButton.addEventListener('click', this.playVideoClicked);
    // tracking listners
    if (moreButton !== null) {
      moreButton.addEventListener('click', this.moreClicked);
    }
    fittingButton.addEventListener('click', this.fittingClicked);

  };

  this.moreClicked = function(event) {
    trackEvent('navigation', 'Results', 'Product Details');
  };

  this.fittingClicked = function(event) {
    trackEvent('navigation', 'Results', 'Find A Fitting Location');
  };

    this.homeClicked = function (event) {
      window.ironSelector.hideProgressBar()
      let override = restartButton.getAttribute('data-url-override');
      closeAccordion();
        self.closeCompare();
        window.resizeFrame();
    if (override === null || override === undefined || override === "") {
      nextPage = "home";
      self.close();
      trackEvent('navigation', 'Home');
    } else {
      // window.location.href = override;
      parent.window.location.href = override;
    }
  };

  this.sendResultsClicked = function () {
    console.log('TODO: Calc sign in or success');
    overlay.openSendResults('sign-in', primaryId, alternateId, primaryFIid, alternateFIid);
  }

  this.previousClicked = function(event) {
      nextPage = "question";
      closeAccordion();
      self.closeCompare();
    window.ironSelector.clearProgressBar(-1);
      self.close();
      window.resizeFrame();
    trackEvent('navigation', 'Previous');
  };

  this.alternativeClicked = function(event) {
      nextPage = "alternative";
      closeAccordion();
      self.closeCompare();
    self.close();
    trackEvent('navigation', 'Results', 'See Alternative Results');
  };

  this.primaryClicked = function(event) {
      nextPage = "primary";
      closeAccordion();
      self.closeCompare();
    self.close();
    trackEvent('navigation', 'Results', 'See Primary Results');
  };

  this.compareClicked = function () {
    // console.log('TODO: Compare!');
      // overlay.openCompareOverlay();

      closeAccordion();
      mainEl.classList.add('results-compare');
      compareTitle.style.display = 'block';
      alternativeTitle.style.display = 'none';
      primaryTitle.style.display = 'none';

      compareButton.classList.add('active');
      showAlternativeButton.classList.remove('active');
      showPrimaryButton.classList.remove('active');

      mode = 'compare';

      overlay.openCompareOverlay(function () { });
  }

  this.whyClicked = function () {
    overlay.openWhyWindow(ironId);
  }

  let videoEl;
  this.playVideoClicked = function () {
    videoEl = ResultsElement.querySelector('video[data-iron-video="' + ironId +'"]');
    videoEl.pause();
    videoEl.currentTime = 0;
    videoEl.play();
    mpiButtonWrap.classList.add('is-hidden');
    clubVideo.classList.add('is-active');
    clubVideo.clientHeight;
    clubVideo.classList.add('is-visible');
    closeVideoButton.addEventListener('click', self.closeVideoClicked);
  }

  this.closeVideoClicked = function () {
    mpiButtonWrap.classList.remove('is-hidden');
    closeVideoButton.removeEventListener('click', self.closeVideoClicked);
    clubVideo.classList.remove('is-visible');
    setTimeout(function() {
      if (videoEl) {
        videoEl.pause();
        videoEl.currentTime = 0;
      }
      clubVideo.classList.remove('is-active');
    }, 300);
  }

  this.disableControls = function () {
    restartButton.removeEventListener('click', this.homeClicked);
    sendResultsButton.removeEventListener('click', this.sendResultsClicked);
    showAlternativeButton.removeEventListener('click', this.alternativeClicked);
    showPrimaryButton.removeEventListener('click', this.primaryClicked);
    compareButton.removeEventListener('click', this.compareClicked);
    //btnWhy.removeEventListener('click', this.whyClicked);
    //playVideoButton.removeEventListener('click', this.playVideoClicked);
    if (moreButton !== null) {
      moreButton.removeEventListener('click', this.moreClicked);
    }
    fittingButton.removeEventListener('click', this.fittingClicked);
    };

    this.closeCompare = function () {
        if (mode == 'compare') {
            console.log('close compare');
            self.quickHide();
            mainEl.classList.remove('results-compare');
            overlay.closeCompareWindow();
            mode = '';
        }
    }

  this.quickHide = function () {
    console.log('quick hide');
    //self.closeVideoClicked();
    timeline.kill();
    timeline = new TimelineLite({onComplete: quickHideComplete});
    timeline.to([ctaButtons, clubImage, clubName, learnMore, primaryTitle, alternativeTitle, logo, description, btnWhy, mpiButton], Application.tweenLength, {opacity: 0});
    timeline.timeScale(1.5);
    timeline.play();
  }

  function quickHideComplete() {
    console.log('hide compare complete');
    overlay.openCompareOverlay(self.quickShow);
  }

  this.quickShow = function() {
    console.log('quick show');
    timeline.kill();
    timeline = new TimelineLite();
    timeline.to([ctaButtons, clubImage, clubName, learnMore, primaryTitle, alternativeTitle, logo, description, btnWhy, mpiButton], Application.tweenLength, {opacity: 1});
    timeline.timeScale(1.5);
    timeline.play();
  }

  this.close = function () {
    console.log('close ' + nextPage);
    //this.closeVideoClicked();
    this.disableControls();
    if (nextPage === "home") {
      window.ironSelector.completeProgressBar();
    }
    timeline.kill();
    timeline = new TimelineLite({onComplete: closeComplete});
    timeline.to([clubImage, clubName, ctaButtons], Application.tweenLength, {opacity: 0});
    timeline.to(learnMore, Application.tweenLength, {opacity: 0}, Application.tweenStagger);
    timeline.to([primaryTitle, alternativeTitle, description, mpiButton], Application.tweenLength, {opacity: 0}, Application.tweenStagger);
    timeline.to(background, Application.tweenLength, {opacity: 0}, Application.tweenStagger);
    timeline.timeScale(1.5);
    timeline.play();
  };

  function closeComplete() {
    mainEl.classList.remove('results-visible');
    // console.log('closeComplete ' + nextPage);
    timeline.kill();
    timeline = null;
    ResultsElement.style.display = 'none';
    ResultsElement.classList.remove('show-' + ironId);
    if (nextPage === "home") {
      // console.log('reset');
      nextPage = "primary";
      window.ironSelector.reset();
    } else if (nextPage === "question") {
      // console.log('previous');
      nextPage = "primary";
      window.ironSelector.questionClosed(-1);
    }else if (nextPage === "primary") {
      console.log('primary');
      self.open();
    }else if (nextPage === "alternative") {
      console.log('alternative');
      self.open();
    }
    }


    function closeAccordion() {
        isExpanded = false;
        let accordionWrapper = document.querySelector('.results-accordion-wrapper.is-active');
        if (accordionWrapper) {
            let accordion = document.querySelector('.results-accordion-wrapper.is-active .results-accordion');
            accordion.style.height = 0;
            accordionWrapper.classList.remove('is-active');
        }
        mainEl.classList.remove('results-expanded');
        window.resizeFrame();
    }


    var Accordion = function () {

        var
            toggleItems,
            items;

        var _init = function () {
            toggleItems = document.querySelectorAll('.btn-results-accordion');
            toggleItems = Array.prototype.slice.call(toggleItems);
            items = document.querySelectorAll('.results-accordion');
            items = Array.prototype.slice.call(items);

            _addEventHandlers();
            TweenLite.set(items, { visibility: 'visible' });
            TweenLite.from(items, 0.9, { opacity: 0, x: -100, ease: Power1.easeOut }, 0.3)
        }

        var _addEventHandlers = function () {
            toggleItems.forEach(function (element, index) {
                element.addEventListener('click', _toggleItem, false);
            });
        }

        var _toggleItem = function () {
            var parent = this.parentNode;
            var content = parent.children[1];
            if (!parent.classList.contains('is-active')) {
                isExpanded = true;
                parent.classList.add('is-active');
                TweenLite.set(content, { height: 'auto' })
                TweenLite.from(content, 0.6, { height: 0, immediateRender: false, ease: Power1.easeOut })
                mainEl.classList.add('results-expanded');
            } else {
                isExpanded = false;
                parent.classList.remove('is-active');
                TweenLite.to(content, 0.3, { height: 0, immediateRender: false, ease: Power1.easeOut })
                mainEl.classList.remove('results-expanded');
            }
            window.resizeFrame();

        }

        return {
            init: _init
        }

    }();

    Accordion.init();

};

export default Results;

